import type { CSSProperties, FunctionComponent } from "react"

import styles from "./Circle.module.css"

type CircleProps = {
  globalXDelta: number
  globalYDelta: number
  name: string
  percent: number
}

export const Circle: FunctionComponent<CircleProps> = props => {
  const { globalXDelta, globalYDelta, name, percent } = props

  return (
    <li
      className={styles.main}
      style={
        {
          "--CircleCurrentSize": percent,
          "--GlobalXDelta": `${globalXDelta}px`,
          "--GlobalYDelta": `${globalYDelta}px`,
        } as CSSProperties
      }
    >
      <span className="sr-only">{name} :</span> {percent}%
    </li>
  )
}
